<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Wyślij SMS
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-model="form.phone"
                    :rules="formRules.phone"
                    class="pt-0"
                    type="text"
                    label="Telefon"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-textarea
                    v-model="form.content"
                    rows="7"
                    class="pt-0"
                    label="Treść"
                    no-resize
                    hint="[link] zostanie podmienione na poprawny link"
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  large
              >Wyślij&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalOrderSms',
  props: {
    item: {},
  },
  mixins: [
  ],
  created() {
  },
  data() {
    return {
      dialog: false,
      service: null,
      form: {
        phone: '',
        content: "Dzień dobry,\n" +
            "\n" +
            "zgodnie z rozmową telefoniczną przesyłamy link do usługi:\n" +
            "[link]\n" +
            "\n" +
            "Pozdrawiamy,\n" +
            "Zespół WasteMaster",
      },
      formRules: {
        phone: [(value) => !!value || 'Wpisz numer telefonu'],
        content: [(value) => !!value || 'Wpisz treść'],
      },
      valid: false,
    }
  },
  methods: {
    open(service) {
      this.dialog = true
      this.service = service;
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      api
          .post('/api/service/' + this.service.id + '/sendSms',
              this.form
          )
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'SMS został wysłany.',
            });
            this.$router.push({name: 'orders'})
          })
          .catch((error) => {
            console.error('Error when adding a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
